export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";